module.exports = __webpack_public_path__ + "img/r3-checkmark.95602862.svg";